export const qs = document.querySelector.bind(document)
